// src/store/toastStore.ts
import { create } from 'zustand';
import type { ToastMessage } from 'primereact/toast';

type ToastState = {
  queue: ToastMessage[];
  enqueue: (msg: ToastMessage | ToastMessage[]) => void;
  success: (summary: string, detail?: string, life?: number) => void;
  error: (summary: string, detail?: string, life?: number) => void;
  info: (summary: string, detail?: string, life?: number) => void;
  warn: (summary: string, detail?: string, life?: number) => void;
  flush: () => ToastMessage[];
  clear: () => void;
};

export const useToastStore = create<ToastState>((set, get) => ({
  queue: [],

  enqueue: (msg) =>
    set((s) => ({
      queue: s.queue.concat(Array.isArray(msg) ? msg : [msg]),
    })),

  success: (summary, detail, life = 2500) =>
    get().enqueue({ severity: 'success', summary, detail, life }),

  error: (summary, detail, life = 5000) =>
    get().enqueue({ severity: 'error', summary, detail, life }),

  info: (summary, detail, life = 3000) =>
    get().enqueue({ severity: 'info', summary, detail, life }),

  warn: (summary, detail, life = 4000) =>
    get().enqueue({ severity: 'warn', summary, detail, life }),

  flush: () => {
    const q = get().queue;
    set({ queue: [] });
    return q;
  },

  clear: () => set({ queue: [] }),
}));
